<template>
  <b-modal
    id="modal-import-history"
    :title="$t('global.importResult.historyUpload')"
    class="mc-modal"
    size="xl"
    centered
    scrollable
    ok-variant="outline-primary"
    :ok-title="$t('global.action.close')"
    title-class="text-white"
    header-close-variant="light"
    ok-only
    @show="onModalShow"
  >
    <div id="tickets-table_filter" class="dataTables_filter text-end">
      <label
        class="d-inline-flex align-items-center mc-table-view__search ms-2"
        @click="focusSearch"
      >
        <i class="mc-fa fas fa-search"></i>
        <b-form-input
          ref="searchInput"
          v-model="filter"
          type="search"
          :placeholder="$t('global.search') + '...'"
          class="ms-2"
        />
      </label>
    </div>

    <div class="table-responsive my-3 border border-1">
      <b-table
        :items="importHistories"
        :fields="fields"
        empty-table
        show-empty
        :busy="$apollo.queries.importHistory.loading"
        :empty-text="$t('global.emptyTable')"
        :empty-filtered-text="$t('global.emptyFilteredTable')"
        :per-page="perPage"
        :filter="filter"
        :current-page="currentPage"
        class="datatables"
        responsive="md"
        @filtered="onFiltered"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle" />
          </div>
        </template>
        <template #cell(importOn)="row">
          <p class="my-0">
            {{ momentDateShortMonth(row.value) }}
          </p>
          <p class="text-muted my-0">
            {{ momentTime(row.value) }}
          </p>
        </template>

        <template #cell(status)="data">
          <span v-if="data.item.totalFailed === 0" class="mc-status mc-status--green">
            {{ $t('global.success') }}
          </span>
          <span v-else-if="data.item.totalSuccess === 0" class="mc-status mc-status--red">
            {{ $t('global.failed') }}
          </span>
          <span
            v-else-if="data.item.totalSuccess > 0 && data.item.totalFailed > 0"
            class="mc-status mc-status--yellow"
          >
            {{ $t('global.importResult.partialSuccess') }}
          </span>
        </template>
      </b-table>
    </div>
    <div class="row mt-3">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            {{ $t('global.text.displays') }}
            <b-form-select
              v-model="perPage"
              class="form-select form-select-sm"
              size="sm"
              :options="pageOption"
            />
            {{ $t('global.text.entries') }}
            .
            <p>
              {{ $t('global.text.displays') }}
              <strong>{{ filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0 }}</strong>
              -
              <strong>{{ Math.min(filteredItems.length, currentPage * perPage) }} </strong>&nbsp;{{
                $t('global.object.of')
              }}&nbsp;<strong>{{ filteredItems.length }}</strong>
            </p>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" />
          </ul>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { Helper } from '@/mixin/helper'
import { GET_CUT_OFF_ENGINE_UPLOAD_HISTORY } from '@/services/api/setting/engineOff/engineOff'
export default {
  mixins: [Helper],
  apollo: {
    importHistory: {
      query: GET_CUT_OFF_ENGINE_UPLOAD_HISTORY,
      variables() {
        return {
          filter: {
            model: 'cut-off-engine',
            orderBy: [JSON.stringify({ importOn: 'desc' })],
          },
        }
      },
      manual: true,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          this.initData(data)
        }
      },
      error(error) {
        console.log('errors', error.graphQLErrors)
      },
    },
  },
  data() {
    return {
      importHistories: [],
      filteredItems: [],
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOption: [10, 25, 50, 100],
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'importOn',
          label: this.$t('global.importHistory.time'),
        },
        {
          key: 'filename',
          label: this.$t('global.importHistory.file'),
        },
        {
          key: 'status',
          label: this.$t('global.importHistory.status'),
        },
        {
          key: 'users.fullname',
          label: this.$t('global.importHistory.uploadBy'),
        },
      ]
    },
  },
  methods: {
    onModalShow() {
      this.filteredItems = []
      this.filter = null
      this.totalRows = 1
      this.currentPage = 1
      this.perPage = 10
      this.refreshData()
    },
    focusSearch() {
      this.$refs.searchInput.focus()
    },
    onFiltered(filteredItems) {
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    initData(data) {
      this.importHistories = data.importHistory.importHistory
      this.filteredItems = data.importHistory.importHistory
      this.totalRows = data.importHistory.importHistory?.length
    },
    refreshData() {
      this.$apollo.queries.importHistory.refetch()
    },
  },
}
</script>
